import { weekSelection } from './collectionPageData'

export interface MenuItemsTypes {
  name: string
  linkId: string
}

export const menuItems: MenuItemsTypes[] = [
  {
    name: `${weekSelection.anonce?.anchorName}`,
    linkId: `/#collection-${weekSelection.id}`,
  },
  {
    name: 'Все новостройки',
    linkId: '/#newBuildings',
  },
  {
    name: 'Подборки',
    linkId: '/#selections',
  },
  {
    name: '<span class="dot-top-end dot-top-end--tangelo">Для инвестиций</span>',
    linkId: '/#investment-banner',
  },
  {
    name: 'Статьи',
    linkId: '/#articles',
  },
  // {
  //   name: 'Обратная связь',
  //   linkId: '/#feedback',
  // },
]

export const menuItems2: MenuItemsTypes[] = [
  {
    name: 'Популярное',
    linkId: '/#popular',
  },
  {
    name: 'По инфраструктуре',
    linkId: '/#infrastructure',
  },
  {
    name: 'По местоположению',
    linkId: '/#location',
  },
]
